module.exports = __webpack_public_path__ + "img/authorityLogo15.3b169088.png";